import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { FormBuilder } from '../../components/applications/FormBuilder';
import { motion } from 'framer-motion';
import { Save, Eye } from 'lucide-react';
export function ApplicationBuilder() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-3579">
      <Sidebar data-id="element-3580" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-3581">
        <DashboardHeader data-id="element-3582" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-3583">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-3584">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 lg:mb-8 gap-4" data-id="element-3585">
              <div className="min-w-0" data-id="element-3586">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-3587">
                  Application Builder
                </h1>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-3588">
                  Create custom rental application forms.
                </p>
              </div>
              <div className="flex gap-3 flex-shrink-0" data-id="element-3589">
                <button className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors whitespace-nowrap" data-id="element-3590">
                  <Eye className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-3591" />
                  Preview
                </button>
                <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-800 transition-colors whitespace-nowrap" data-id="element-3592">
                  <Save className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-3593" />
                  Save Template
                </button>
              </div>
            </div>

            <FormBuilder data-id="element-3594" />
          </motion.div>
        </div>
      </main>
    </div>;
}